import { createSlice } from '@reduxjs/toolkit';
import { defaultGenericState, GenericState, Wallet } from '../model';
import { addGenericStateListBuilders } from '../slice';
import { getWallets, resetWallet } from './WalletApi';


export interface WalletState extends GenericState<Wallet> {
}

export const walletSlice = createSlice({
    name: 'Wallet',
    initialState: defaultGenericState,
    reducers: {},
    extraReducers: builder => {
        addGenericStateListBuilders(builder, getWallets);
        addGenericStateListBuilders(builder, resetWallet);
    },
});

